import script from "./selectCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./selectCard.vue?vue&type=script&lang=ts&setup=true"

import "./selectCard.vue?vue&type=style&index=0&id=40887e89&lang=stylus&scoped=true"

import exportComponent from "D:\\project\\web\\vysa_wifi_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40887e89"]])

export default __exports__